// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hPUZ","col":"styles_col__1cP6r"};